/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * ======================================================================== */
import { clearCookie, getCookie, setCookie } from "./helpers";
import { furnitureTakeBack } from "./epsilonLabs";
import { epsilonLabsExperiments } from "./epsilonLabs/config";

(function ($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var main = {
		// All pages
		common: {
			init: function () {

				main.common.epsilonLabs();
				main.common.checkout();
				main.common.pretestUnavailableNotice();
				main.common.restoreDraftContactFromSession();
				main.common.initPopups();
				main.common.initCartItemsPopup();
				main.common.customNudgify();
				main.common.fireEvent();
				main.common.shippingMethodsSkeleton();
				main.common.checkoutFabricSample();
				main.common.checkoutPaymentStep();
				main.common.checkoutShippingStep();
				main.common.checkoutFurnitureTakeBack();
				main.common.setSheetQuantity();
				main.common.checkoutDetails();
				main.common.emptyCheckout();
				main.common.singleProductAddToCart();
				main.common.handleWoocommerceAutoCouponNotice();
				main.common.stickyTableOfContents();
				main.common.klaviyo();
				main.common.checkoutEpsilonLabs();
				main.common.orderPaymentReminderPage();

				main.common.priceTest();

				// Add loader to "Add to cart" button after cart form submission.
				$("form.cart").submit(function () {
					$(this).find(".single_add_to_cart_button").addClass("mt-button-loading");
				});

				jQuery(function ($) {
					const interval = setInterval(() => {
						const banner = document.querySelector("div.brlbs-cmpnt-dialog.brlbs-relative.brlbs-overflow-hidden.brlbs-shadow-2xl.brlbs-cmpnt-dialog-box");
						if (banner) {
							banner.style.setProperty("bottom", "auto", "important");
							clearInterval(interval);
						}
					}, 300);
				});
			},

			epsilonLabs: function () {
				// The Epsilon Labs script is third party: it can be missing, blocked or
				// still loading. Without this guard the TypeError aborts common.init()
				// and every function after this one silently stops running.
				if (!window.epsilonLab || typeof window.epsilonLab.experimentExists !== "function") {
					return;
				}

				const setExperimentCookies = () => {
					let changed = false;

					epsilonLabsExperiments.forEach(({ id, variationId, cookieName }) => {
						const result = variationId
							? window.epsilonLab.getActiveExperiments?.()[id] === variationId
							: window.epsilonLab.experimentExists(id);

						if (result && !getCookie(cookieName)) {
							setCookie(cookieName, true);
							changed = true;
						}
					});

					return changed;
				};

				setExperimentCookies();

				// The free assembly price (PB-1856) is calculated from the cookie on the server, so
				// a variation reported after the checkout has rendered needs a refresh.
				window.addEventListener("epsilonLabActivated", () => {
					if (setExperimentCookies() && $("form.checkout").length) {
						$("body").trigger("update_checkout");
					}
				});
			},

			checkout: function () {

				$(".ec-address__manually-link").each(function () {
					$(this).html("Manuell eingeben");
				});

				$("body").on("click", ".fc-order_review__collapse, .fc-order-review__mobile-summary-preview", function (e) {
					e.preventDefault();

					const $btn = $(this);
					const $orderReview = $btn.closest(".fc-order-review");
					const isExpanded = !$orderReview.hasClass("fc-order-review--expanded");

					$orderReview.toggleClass("fc-order-review--expanded", isExpanded);
					$orderReview.find(".fc-order_review__collapse").attr("aria-expanded", isExpanded ? "true" : "false");
					$orderReview.find(".fc-order_review__collapse-label").text(isExpanded ? "Weniger" : "Mehr");

					$orderReview.find(".fc-order-review__mobile-summary-preview")
						.stop(true, true)
						[isExpanded ? "slideUp" : "slideDown"](200);

					$orderReview.find(".fc-order-review__summary-details, .fc-order-review__product-row_wrapper")
						.stop(true, true)
						[isExpanded ? "slideDown" : "slideUp"](200);
				});

				const shippingAddressToggle = $(".ec-address__fields.shipping label.fc-checkbox.update_totals_on_change");

				if (shippingAddressToggle.length) {
					$(".ec-address__fields.shipping").after(shippingAddressToggle);
				}
			},

			pretestUnavailableNotice: function () {
				const checkoutSteps = $(".fc-checkout-steps").first();

				if (!checkoutSteps.length) {
					return;
				}

				const PRETEST_UNAVAILABLE_PREFIX = "pretest-unavailable:";
				const storageKeys = [];

				try {
					for (let i = 0; i < sessionStorage.length; i++) {
						const storageKey = sessionStorage.key(i);

						if (storageKey && storageKey.indexOf(PRETEST_UNAVAILABLE_PREFIX) === 0) {
							storageKeys.push(storageKey);
						}
					}
				} catch (e) {
					return;
				}

				const readFlag = (value) => {
					try {
						const parsed = JSON.parse(value);

						if (parsed && typeof parsed === "object") {
							return parsed;
						}
					} catch (e) {}

					return { label: value, hasAlternative: false };
				};

				for (const storageKey of storageKeys) {
					const { label: productName, hasAlternative, noun, message } = readFlag(
						sessionStorage.getItem(storageKey),
					);

					// The configurator already offered an alternative, so a second notice would only repeat it.
					if (hasAlternative || !productName || productName === "true") {
						continue;
					}

					const noticeClass = `fc-pretest-notice--${storageKey.slice(PRETEST_UNAVAILABLE_PREFIX.length)}`;

					if (checkoutSteps.find(`.${noticeClass}`).length) {
						continue;
					}

					const notice = $("<p></p>").addClass(`fc-pretest-notice ${noticeClass}`);

					// The configurator sends the text edited in its Control Panel (PB-1913), merge fields filled
					// and `**bold**` as markup; records from before that fall back to the built-in sentence.
					if (typeof message === "string" && message.trim()) {
						message.split("**").forEach((part, index) => {
							if (!part) return;
							notice.append(index % 2 === 1 ? $("<strong></strong>").text(part) : document.createTextNode(part));
						});
					} else {
						notice.append(document.createTextNode(`Das ${noun || "Produkt"} `));
						notice.append($("<strong></strong>").text(productName));
						notice.append(document.createTextNode(
							" ist aktuell nicht verfügbar und wurde daher aus Deiner Konfiguration entfernt. " +
							"Deine übrige Konfiguration bleibt erhalten.",
						));
					}

					checkoutSteps.prepend(notice);
				}
			},

			restoreDraftContactFromSession: () => {
				if (!$("form.checkout").length) return;

				// Apply after Fluid Checkout restores any locally cached field values.
				setTimeout(() => {
					let email;
					let phone;

					try {
						email = window.sessionStorage.getItem("mozart_draft_contact_email")?.trim();
						phone = window.sessionStorage.getItem("mozart_draft_contact_phone")?.trim();
					} catch {
						return;
					}

					for (const [selector, value] of [
						["#billing_email", email],
						["#billing_phone", phone],
					]) {
						const $field = $(selector);

						if (!value || !$field.length || $field.val() === value) continue;

						$field.val(value).trigger("input").trigger("change");
					}

					if (phone) {
						$("#shipping_phone").val(phone);
					}
				}, 0);
			},

			initPopups: function () {

				$("body").on("click", "[data-popup]", function (e) {
					e.preventDefault();

					var src = this.tagName === "a" ? $(this).attr("href") : "#" + $(this).data("popup");

					$.magnificPopup.open({
						items: {
							src: src,
							type: "inline",
						},
					});
				});

			},

			initCartItemsPopup: function () {

				$("body").on("click", "a[href^=\"#cart-item-popup-\"]", function (e) {
					e.preventDefault();

					$.magnificPopup.open({
						items: {
							src: $(this).attr("href"),
							type: "inline",
						},
						callbacks: {
							close: function () {
								history.pushState("", document.title, window.location.pathname + window.location.search);
							},
						},
					});
				});
			},

			customNudgify: function () {
				const customNudgifyElement = $(".nudgify-custom-container");
				$("body").append(customNudgifyElement);

				let isCustomNudgifyShown = false;

				function showCustomNudgify(title, content, position, imageSrc, iconSrc, timeout) {

					if (isCustomNudgifyShown) return;
					isCustomNudgifyShown = true;

					const isLeftPosition = "left" in position;
					customNudgifyElement.addClass(isLeftPosition ? "nudgify-slide-in-left" : "nudgify-slide-in-right");
					customNudgifyElement.show();
					customNudgifyElement.css(position, "0");
					customNudgifyElement.find(".nudgify-custom-title span").html(title);
					customNudgifyElement.find(".nudgify-custom-content p").html(content);
					customNudgifyElement.find(".nudgify-custom-icon img").attr("src", iconSrc);
					customNudgifyElement.find(".nudgify-custom-image img").attr("src", imageSrc);

					setTimeout(function () {
						customNudgifyElement.addClass(isLeftPosition ? "nudgify-slide-out-left" : "nudgify-slide-out-right");
						customNudgifyElement.one("animationend", function () {
							customNudgifyElement.hide();
							isCustomNudgifyShown = false;
							customNudgifyElement.removeClass(isLeftPosition ? "nudgify-slide-out-left" : "nudgify-slide-out-right");
						});
					}, timeout);
				}

				customNudgifyElement.find(".nudgify-custom-closeIcon").on("click", function () {
					customNudgifyElement.hide();
				});

				$(window).on("showCustomNudgify", function (event) {
					const detail = event.originalEvent.detail;
					const screenWidth = $(window).width();
					const positionValue = screenWidth < 761 ? 10 : 30;
					const positionObj = { [detail.position]: positionValue };
					showCustomNudgify(detail.title, detail.content, positionObj, detail.imageSrc, detail.iconSrc, detail.timeout);
				});
			},

			fireEvent: function () {
				$(document).on("click", ".fc-submit-address", function () {
					let zipcode = $("#shipping_postcode").val();
					let secondLastDigit = null;
					let shippingPrice = document.cookie.includes("shipping_price");

					if (zipcode?.length >= 2) {
						secondLastDigit = zipcode.charAt(zipcode.length - 2);
					}

					if (typeof gtag === "function") {
						gtag("event", "entered_user_zipcode", {
							event_category: "zip_code",
							event_label: zipcode,
							send_to: "G-C1ZYK5LW3S",
							custom_timestamp: new Date().getTime(),
						});
					}

					if (shippingPrice) {
						let abLyftExperimentId = 86482694;
						let abLyftVariationId;

						if (secondLastDigit % 2 === 0) {
							// Variation A: Original
							abLyftVariationId = 55011063;
						} else {
							// Variation B: Delivery Service: Value based pricing
							abLyftVariationId = 93511576;
						}

						if (abLyftVariationId) {
							window["ablyft"] = window["ablyft"] || [];
							window["ablyft"].push({
								eventType: "forceVariation",
								experimentId: abLyftExperimentId,
								variationId: abLyftVariationId,
							});

							window.mozartPriceTest = true;

							// Reinitialize AbLyft
							window["ablyft"].reInit();
						}
					}
				});
			},

			shippingMethodsSkeleton: function () {
				$(document.body).on("update_checkout", function () {
					let zip = $("#shipping_postcode").val();
					let secondLastDigit = parseInt(zip[zip.length - 2]);
					let getReplaceMozart7ShippingMethods = document.cookie.includes("replace_mozart_7_shipping_methods");
					let getFcShippingMethodsItem = $(".fc-shipping-methods__item").length === 2;

					if (getReplaceMozart7ShippingMethods && getFcShippingMethodsItem && secondLastDigit % 2 !== 0) {
						$(".fc-shipping-methods").addClass("fc-shipping-methods--loading");
					} else {
						$(".fc-shipping-methods").removeClass("fc-shipping-methods--loading");
					}
				});
			},

			checkoutFabricSample: function () {

				function updatePhoneFieldVisibility() {
					const MOZART_SAMPLE_BOX_PRODUCT_ID = 2339;
					let isOnlySampleBox = true;

					$(".fc-order-review__product_id").each(function () {
						if ($(this).data("product-id") !== MOZART_SAMPLE_BOX_PRODUCT_ID) {
							isOnlySampleBox = false;
						}
					});

					if (isOnlySampleBox) {
						$(".fc-field-billing_phone").hide();
						$(".fc-info-box").next(".fc-section").hide();
						$(".fc-progress-bar__item[data-step=\"payment\"] .fc-progress-bar__label").each(function () {
							$(this).html($(this).html().replace("Zahlung", "Bestellung"));
						});
					} else {
						$(".fc-field-billing_phone").show();
						$(".fc-info-box").next(".fc-section").show();
						$(".fc-progress-bar__item[data-step=\"payment\"] .fc-progress-bar__label").each(function () {
							$(this).html($(this).html().replace("Bestellung", "Zahlung"));
						});
					}
				}

				updatePhoneFieldVisibility();

				$(document).ajaxComplete(function () {
					updatePhoneFieldVisibility();
				});
			},

			setSheetQuantity: function () {
				const product_id = $("#mozart_fitted_sheet_product_id").val();
				const width = $("#mozart_fitted_sheet_width").val();
				const matrasses = $(`#pa_mattress-type_${product_id}`).val();
				const mattressContinuous = $("#mattress_continuous").val();
				const fittedSheetElement = $(`.fc-product[data-product-id="${product_id}"]`);

				if (product_id === "51541" || product_id === "123057") {
					const parent = fittedSheetElement.closest("article");

					if (mattressContinuous === "" && width >= 160 && matrasses === "intercontinental") {
						parent.find(".fc-variations-wrap").append(
							"<div class=\"fc-custom-description\">Du hast die Königliche Matratze mit 2 separaten Matratzen gewählt. Um für beide Matratzen ein Spannbettlaken zu haben, empfehlen wir mindestens 2 Spannbettlaken.</div>",
						);
					}

					$(document).ajaxComplete(function () {
						if (product_id === "51541") {
							if (mattressContinuous === "" && width >= 160 && matrasses === "intercontinental") {
								parent.find(".qty").val(2);
							}
						}
					});
				}
			},

			checkoutPaymentStep: function () {

				$("body").on("updated_checkout", function () {
					let PaymentMethodBACSLabel = $(".fc-section__content label[for=\"payment_method_bacs\"]");
					let PaymentMethodBACSLabelContent = "2% Skonto-Rabatt";

					PaymentMethodBACSLabel.attr("data-after-content", PaymentMethodBACSLabelContent);
					$(".fc-payment-methods").removeClass("fc-payment-methods--loading");
				});
			},

			checkoutShippingStep: function () {
				$(".fc-shipping-dates__item.active").trigger("click");

				function updateOrderReviewDeliveryDate() {
					const $deliveryDate = $(".fc-shipping-dates__item.active input[name='fc_delivery_date']:checked"),
						$deliveryInfo = $(".wc-gzd-cart-info.delivery-time-info");

					$deliveryInfo.show();
					$(".fc-order-review-delivery-date").remove();

					if ($deliveryDate.length && $deliveryDate.data("date")) {
						$deliveryInfo.hide()
							.after("<p class=\"fc-order-review-delivery-date\">Lieferzeit: " + $deliveryDate.data("date") + "</p>");
					}
				}

				$("body")
					.on("change", "input[name='fc_delivery_date']", updateOrderReviewDeliveryDate)
					.on("updated_checkout", updateOrderReviewDeliveryDate);

				// The Series 9 free assembly (PB-1856) preselects the assembly delivery on the server.
				const freeAssembly = $(".fc-shipping-methods[data-free-assembly]").length > 0;
				const $flatRateRadio = $("#shipping_method_0_free_shipping15");
				if (!freeAssembly && $flatRateRadio.length && !$flatRateRadio.prop("checked")) {
					$flatRateRadio.prop("checked", true);
					$("body").trigger("update_checkout");
				}

				const islandCodes = [
					"25980", "25981", "25982", "25983", "25984", "25985", "25986", "25987", "25988", "25989",
					"25990", "25991", "25992", "25993", "25994", "25995", "25996", "25997", "25998", "25999",
					"25938", "25946", "25947", "25849", "25845", "25859", "25863", "27498", "26757", "26571",
					"26548", "26579", "26465", "26474", "26486", "18528", "18546", "18551", "18556", "18565",
					"18569", "18574", "18581", "18586", "17419", "17424", "17429", "17440", "17449", "17454",
					"17459", "23999", "23769", "83209", "78479", "23909", "88131",
				];

				function renderIslandNote() {
					const zip = $("#shipping_postcode").val();

					$(".fc-section__island-note").remove();

					if (islandCodes.includes(zip)) {
						$("#shipping .fc-shipping-delivery-info").after(
							`<div class="fc-section__island-note">
        Hinweis für Inselbewohner:innen 🌴 Wir liefern nicht auf Inseln. 
        Du kannst dennoch bestellen, unser Kundensupport meldet sich 
        bei Dir zwecks Lieferabstimmung.
      </div>`,
						);
					}
				}

				$("body").on("updated_checkout", function () {
					$(".fc-shipping-dates__item.active").trigger("click");
				});

				$(document.body).on("updated_checkout update_checkout", function () {
					renderIslandNote();
				});

				$(document.body).on("change", "#shipping_postcode", renderIslandNote);

				renderIslandNote();
			},

			checkoutFurnitureTakeBack: function () {
				if (!window.epsilonLab || !furnitureTakeBack()) {
					return;
				}

				let forcedPostcode = null;

				function applyFurnitureTakeBackVariation() {
					const zipcode = ($("#shipping_postcode").val() || "").trim();
					const secondLastDigit = zipcode.charAt(zipcode.length - 2);

					if (zipcode.length < 4 || !/^\d$/.test(secondLastDigit) || !$("#shipping_method_0_flat_rate14").length) {
						return;
					}

					if (forcedPostcode === zipcode) {
						return;
					}

					forcedPostcode = zipcode;

					window.epsilonLab.forceVariation(225, Number(secondLastDigit) % 2 === 0 ? 399 : 398);
					window.epsilonLab.activatePage("add-furniture-take-back");
				}

				$(document.body).on("updated_checkout", applyFurnitureTakeBackVariation);

				applyFurnitureTakeBackVariation();
			},

			checkoutDetails: function () {
				const getSelector = (element) => `.fc-order-review__${element}`;

				const rowSelector = getSelector("product-row");
				const detailsSelector = getSelector("product-details");
				const toggleSelector = getSelector("product-details-toggle");

				$(document).on("click", toggleSelector, function (e) {
					e.preventDefault();

					const $toggle = $(e.currentTarget);
					const $row = $toggle.closest(rowSelector);
					const $details = $row.find(detailsSelector).first();

					if (!$details.length) return;

					const willOpen = !$details.is(":visible");

					$details.stop(true, true).animate(
						{ height: "toggle", opacity: "toggle" },
						300,
					);

					const $icon = $toggle.find("svg");
					if ($icon.length) {
						$icon.toggleClass("fc-order-review__product-details-toggle-active", willOpen);
					}

					$toggle.find("span").first()
						.text(willOpen ? "Details verbergen" : "Details anzeigen");
				});
			},

			emptyCheckout: function () {
				$("body").on("updated_checkout", function () {
					$(".mozart-bed-custom-expire-message")
						.closest(".woocommerce-error")
						.toggleClass("woocommerce-custom-error--empty-cart woocommerce-error");
				});
			},

			priceTest: function () {
				const $body = $("body");

				if (!$body.hasClass("postid-2339")) { // Fabric sample page
					return;
				}

				const { mozartSale } = window;

				if (!mozartSale) return;

				document.body.addEventListener("mozart_zip_questionnaire_choose", function (event) {
					const { zip } = event.detail;

					const isEven = zip % 2 === 0;

					$(".mozart-sale-notes__discounts li").each(function (i, elem) {
						const discount = mozartSale.discounts[i % 4];

						if (!discount) return;

						const $elem = $(elem);
						const amount = discount.amount + (isEven ? 500 : 0),
							limit = discount.limit + (isEven ? 500 : 0),
							from = discount.from + (isEven ? 500 : 0);

						let text = "";

						if (!limit || limit >= 999999) {
							text = `ab ${Intl.NumberFormat("de-DE").format(from)} €`;
						} else if (!from) {
							text = `bis ${Intl.NumberFormat("de-DE").format(limit)} €`;
						} else {
							text = `ab ${Intl.NumberFormat("de-DE").format(from)} bis ${Intl.NumberFormat("de-DE").format(limit)} €`;
						}

						$elem.find(".mozart-sale-notes__discount-amount").text(amount);
						$elem.find(".mozart-sale-notes__discount-text").text(text);
					});
				});
			},

			singleProductAddToCart: function () {

				const $body = $("body");

				if (!$body.hasClass("single-product") || $body.hasClass("postid-2339")) {
					return;
				}

				function toggleMiniCart() {
					$(".mini-cart-custom").toggleClass("active");
					$(".mini-cart-custom-overlay").addClass("mini-cart-custom-overlay-active");
					$("body").addClass("no-scroll");
				}

				function displayWooCommerceErrors(errors) {
					let errorHtml = "<ul class=\"woocommerce-error\" role=\"alert\">";

					errors.forEach(error => {
						let cleanedError = error.replace(/<a\b[^>]*>(.*?)<\/a>/gi, "");
						errorHtml += `<li>${cleanedError}</li>`;
					});

					errorHtml += "</ul>";

					$(".woocommerce-error").remove();
					$("#main-header").after(errorHtml);
				}


				$("form.cart").submit(function (e) {
					e.preventDefault();

					$.ajax({
						type: "POST",
						url: `${mozartData.ajaxUrl}?action=mozart_single_product_add_to_cart`,
						data: {
							product_id: $(this).find(".single_add_to_cart_button").val(),
							quantity: $(this).find("input[name=\"quantity\"]").val(),
						},
						success: function (response) {
							if (response.success) {
								$(".single_add_to_cart_button").removeClass("mt-button-loading");
								$(".mini-cart-custom").html(response.data.cart_html);
								$(".mini-cart-items-counter").html(response.data.cart_item_count);
								toggleMiniCart();
							} else {
								displayWooCommerceErrors(response.data);
								$(".single_add_to_cart_button").removeClass("mt-button-loading");
							}
						},
					});

				});
			},

			handleWoocommerceAutoCouponNotice: function () {
				let noticesWrapper = $(".woocommerce-notices-wrapper");

				$(document).ajaxComplete(function (event, xhr, settings) {
					if (!settings.url || settings.url.indexOf("wc-ajax=update_order_review") === -1) {
						return;
					}

					let message = getCookie("woocommerce_notices");

					if (!message) {
						return;
					}

					clearCookie("woocommerce_notices");

					let wrapper = $(".woocommerce-notices-wrapper:visible").first();

					if (!wrapper.length) {
						wrapper = $(".woocommerce-notices-wrapper").first();
					}

					wrapper.find(".woocommerce-message, .woocommerce-error").remove();
					wrapper.append(message);
				});

				$(".fc-button").on("click", function () {
					noticesWrapper.html("");
				});
			},

			stickyTableOfContents: function () {
				const headerOffset = 80;

				function smoothScroll(targetId) {
					const targetElement = $("#" + targetId);
					if (targetElement.length) {
						const elementPosition = targetElement.offset().top;
						const offsetPosition = elementPosition - headerOffset;

						$("html, body").animate({
							scrollTop: offsetPosition,
						}, 500);
					}
				}

				const hash = window.location.hash.substring(1);

				if (hash && hash !== "/") {
					smoothScroll(hash);
				}
			},

			klaviyo: function () {
				let emailNodes = jQuery("input[id*=\"email\"]:visible, input[name*=\"email\"]:visible");

				emailNodes.on("change", function () {
					let email = $.trim($(this).val());

					if (email && /@/.test(email)) {
						$.post({
							url: mozartData.ajaxUrl,
							data: {
								action: "on_checkout_email_change",
								email: email,
								send_nonce: mozartData.sendNonce,
							},
						});
					}
				});
			},

			checkoutEpsilonLabs: function () {

				$("form.checkout").on("checkout_place_order", function () {

					let bucketing = localStorage.getItem("epsilon_lab_bucketing") || "";
					let visitor = localStorage.getItem("epsilon_lab_visitor_id") || "";
					// The session lives in the Labs script (GA4 model, shared by all tabs), not in storage we read directly
					let sessionId = (window.epsilonLab && typeof window.epsilonLab.getSessionId === "function" && window.epsilonLab.getSessionId()) || "";

					bucketing = bucketing.trim().replace(/'/g, "\\'");

					$(this).append(
						"<input type='hidden' name='epsilon_lab_bucketing' value='" + bucketing + "'>",
					);

					$(this).append(
						"<input type='hidden' name='epsilon_lab_visitor_id' value='" + visitor + "'>",
					);

					$(this).append(
						"<input type='hidden' name='epsilon_lab_session_id' value='" + sessionId + "'>",
					);
				});
			},

			orderPaymentReminderPage: function () {
				const $orderReview = $("#order_review");
				if (!$orderReview.length) return;

				const $methods = $orderReview.find("input[name=\"payment_method\"]");

				function togglePaymentBoxes() {
					const $checked = $methods.filter(":checked");
					if (!$checked.length) return;

					const $currentBox = $checked
						.closest(".wc_payment_method")
						.find(".payment_box");

					$orderReview
						.find(".payment_box")
						.not($currentBox)
						.stop(true, true)
						.slideUp(200);

					$currentBox
						.stop(true, true)
						.slideDown(200);
				}

				togglePaymentBoxes();

				$methods.on("change", togglePaymentBoxes);
			},
		},
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function (func, funcname, args) {
			var namespace = main;
			funcname = (funcname === undefined) ? "init" : funcname;
			if (func !== "" && namespace[func] && typeof namespace[func][funcname] === "function") {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function () {
			UTIL.fire("common");
			$.each(document.body.className.replace(/-/g, "_").split(/\s+/), function (i, classnm) {
				UTIL.fire(classnm);
			});
		},
	};

	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
